"use client";

import ReactPaginate from "react-paginate";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
	handlePageClick: (page: number) => void; // Function that takes a page number and returns void
	totalItems: number; // Total number of items to be paginated
	itemsPerPage: number; // Number of items per page
	currentPage: number; // Current active page
}

const Pagination = ({
	handlePageClick,
	totalItems,
	itemsPerPage,
	currentPage,
}: PaginationProps) => {
	// const pageCount = Math.ceil(totalItems / itemsPerPage);

	return (
		<div className="flex items-center justify-between w-full mx-auto mt-4">
			<small className="text-muted-foreground">ທັງໝົດ {totalItems} ລາຍການ</small>
			<div className="flex items-center gap-4">
				<small className="w-full text-muted-foreground">
					ໜ້າ {currentPage} / {Math.ceil(totalItems / itemsPerPage)}
				</small>

				<ReactPaginate
					containerClassName="w-full flex items-center justify-end gap-[15px]"
					disabledClassName="disabled:cursor-not-allowed disabled:opacity-25"
					disabledLinkClassName="disabled:cursor-not-allowed disabled:opacity-25"
					previousLabel={
						<div className="w-[40px] h-[40px] rounded-[4px] flex items-center justify-center bg-[#F2F2F2] ">
							<ChevronLeft className="w-[20px] h-[20px]" />
						</div>
					}
					nextLabel={
						<div className="w-[40px] h-[40px] rounded-[4px] flex items-center justify-center bg-[#F2F2F2]">
							<ChevronRight className="w-[20px] h-[20px]" />
						</div>
					}
					breakLabel={"..."}
					pageClassName="w-[40px] h-[40px]  bg-[#F2F2F2] rounded-[4px]  text-black flex items-center justify-center rounded-[4px]"
					marginPagesDisplayed={1}
					pageRangeDisplayed={5}
					pageLinkClassName="w-full h-full flex items-center justify-center"
					activeLinkClassName="w-[40px] h-[40px] rounded-[4px] text-white bg-[#216B4C]  flex items-center justify-center  rounded-[4px]"
					onPageChange={({ selected }) => handlePageClick(selected + 1)}
					forcePage={currentPage ? currentPage - 1 : undefined}
					// pageCount={25}
					pageCount={Math.ceil(totalItems / itemsPerPage)}
				/>
			</div>
		</div>
	);
};

export default Pagination;
